'use strict';

/**
  * Test if element is in view or not
  * @function isInViewport
  * @param {HTMLElement} element for which the test is performed
  * @returns {boolean} - Return true if element is present in view and false otherwise
*/
var isInViewport = function (element) {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
};

/**
  * Debouncing for high frequency task
  * @function debounce
  * @param {function} callBack - callback to execute
  * @param {string} delay - delay to execute
  * @returns {function} - function
*/
var debounce = function (callBack, delay) {
    let timeoutId;
    return function () {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(()=> {
            callBack();
            clearTimeout(timeoutId);
        }, delay);
    };
};

module.exports = {
    isInViewport: isInViewport,
    debounce: debounce
};
